// Response codes returned by the enrollment to SFT product (POST /profile) API.
export const respCodes = Object.freeze({
  // Enrollment to SFT product succeeded and registration is marked completed.
  SUCCESS: 'RESP000',
  // Enrollment to SFT product was previously completed; the user is OK to log in to FileXpress.
  REGISTERED: 'RESP001',
  // Enrollment to SFT product failed due to a conflict (email tied to another
  // product) — the user needs to go through the sign-up flow (create a new account).
  CONFLICT: 'RESP416',
  // Enrollment to SFT product succeeded, but the sign-up token could not be
  // updated; the user needs to log in again to continue.
  ENROLLED_RELOGIN_REQUIRED: 'RESP417',
  // /welcome/authenticate terminal registration statuses (cannot continue):
  REG_COMPLETED: 'RESP418', // user is already registered
  REG_EXPIRED: 'RESP419', // registration link expired
  REG_CANCELLED: 'RESP420', // registration cancelled
  REG_NOT_FOUND: 'RESP421', // no registration found for the user
  // Unexpected server error — transient, so the user can retry.
  SERVER_ERROR: 'RESP500',
});

// HTTP status codes referenced by the enrollment to SFT product / login flow.
export const httpStatus = Object.freeze({
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
});
